import { useCustomMutation } from '../../graphql';

export const useAssignFeatureToWorkspaces = () => {
  return useCustomMutation({ query: ASSIGN_FEATURE_TO_WORKSPACES });
};

export const ASSIGN_FEATURE_TO_WORKSPACES = `
  mutation AssignFeatureToWorkspaces($input: AssignFeatureToWorkspacesInput!) {
    feature {
      assignFeatureToWorkspaces(input: $input) {
        success
        message
      }
    }
  }
`;
